import axiosInstance from './axiosInstance';

export const fetchSubscriptionDetails = async (newPlan) => {
  try {
    const response = await axiosInstance.post(
      `/payment/change-subscription-details`,
      null,
      {
        params: {
          new_plan_id: newPlan,
        },
      }
    );

    const data = response?.data;

    if (data.status === 200 && data.message) {
      return { message: data.message };
    }

    return data;
  } catch (error) {
    console.error('Error fetching subscription details:', error?.response || error);
    throw error;
  }
};
export const createCheckoutSession = async (priceId) => {
  try {
    const response = await axiosInstance.post(
      '/payment/create-checkout-session',
      { priceId }
    );

    return response?.data;
  } catch (error) {
    console.error('Error creating checkout session:', error?.response || error);
    return null;
  }
};
export const createTokenCheckoutSession = async (priceId) => {
  try {
    const response = await axiosInstance.post(
      `/payment/create-token-pack-payment?price_id=${priceId}`
    );

    return response?.data;
  } catch (error) {
    console.error('Error creating checkout token session:', error?.response || error);
    return null;
  }
};